import { render, staticRenderFns } from "./P-Sticker.vue?vue&type=template&id=58ffe600&lang=pug&"
import script from "./P-Sticker.vue?vue&type=script&lang=js&"
export * from "./P-Sticker.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports